export const LIMIT_GET_PRODUCTS = 20;
export const LIMIT_GET_RESERVATIONS = 20;
export const LIMIT_GET_SUBSCRIBERS = 20;
export const LIMIT_GET_ORDERS = 20;
export const LIMIT_GET_OFFERS = 20;
